{
    const SELECTORS = {
        wrapper: '.bux-tabpanel',
        tab: '.bux-tabpanel__tab',
        panel: '.bux-tabpanel__panel',
    };

    const KEYS = {
        left: 'ArrowLeft',
        right: 'ArrowRight',
        home: 'Home',
        end: 'End',
    };

    /**
     * Initialize Tab Panel functionality
     */
    function initTabPanels(): void {
        const panels = document.querySelectorAll<HTMLElement>(SELECTORS.wrapper);
        if (panels.length === 0) return;

        for (const panel of panels) setupSingleTabPanel(panel);
    }

    /**
     * Set up individual Tab Panel
     */
    function setupSingleTabPanel(panelContainer: HTMLElement): void {
        const tabs = [...panelContainer.querySelectorAll<HTMLElement>(SELECTORS.tab)];
        const panels = [...panelContainer.querySelectorAll<HTMLElement>(SELECTORS.panel)];

        if (tabs.length === 0) return;

        for (const tab of tabs) {
            tab.addEventListener('click', (event) => handleTabClick(event, tabs, panels));
            tab.addEventListener('keydown', (event) => handleTabKeydown(event, tabs));
        }
    }

    function handleTabClick(
        event: MouseEvent,
        allTabs: HTMLElement[],
        allPanels: HTMLElement[]
    ): void {
        const clickedTab = event.currentTarget as HTMLElement;
        if (!clickedTab) return;

        updateTabAttributes(clickedTab, allTabs);
        const controlsId = clickedTab.getAttribute('aria-controls');
        if (controlsId) {
            const targetPanel = document.querySelector(`#${controlsId}`);
            if (targetPanel instanceof HTMLElement) {
                updatePanelAttributes(targetPanel, allPanels);
            }
        }
    }

    function handleTabKeydown(event: KeyboardEvent, tabs: HTMLElement[]): void {
        const currentTab = event.currentTarget as HTMLElement;
        const currentIndex = tabs.indexOf(currentTab);

        if (currentIndex === -1) return;

        let targetIndex: number | undefined = undefined;

        switch (event.key) {
            case KEYS.left: {
                targetIndex = currentIndex === 0 ? tabs.length - 1 : currentIndex - 1;
                event.preventDefault();
                break;
            }

            case KEYS.right: {
                targetIndex = currentIndex === tabs.length - 1 ? 0 : currentIndex + 1;
                event.preventDefault();
                break;
            }

            case KEYS.home: {
                targetIndex = 0;
                event.preventDefault();
                break;
            }

            case KEYS.end: {
                targetIndex = tabs.length - 1;
                event.preventDefault();
                break;
            }
        }

        if (targetIndex !== undefined) {
            focusAndActivateTab(tabs[targetIndex]);
        }
    }

    function updateTabAttributes(activeTab: HTMLElement, allTabs: HTMLElement[]): void {
        for (const tab of allTabs) {
            const isActive = tab === activeTab;
            tab.setAttribute('aria-selected', isActive ? 'true' : 'false');

            if (isActive) {
                tab.removeAttribute('tabindex');
            } else {
                tab.setAttribute('tabindex', '-1');
            }
        }
    }

    function updatePanelAttributes(activePanel: HTMLElement, allPanels: HTMLElement[]): void {
        for (const panel of allPanels) {
            const isActive = panel === activePanel;

            if (isActive) {
                panel.removeAttribute('hidden');
                panel.setAttribute('tabindex', '0');
            } else {
                panel.setAttribute('hidden', 'hidden');
                panel.setAttribute('tabindex', '-1');
            }
        }
    }

    function focusAndActivateTab(tab: HTMLElement): void {
        tab.focus();
        tab.click();
    }

    initTabPanels();
}
